import { render, staticRenderFns } from "./StarResources.vue?vue&type=template&id=7d9f18a7&scoped=true&"
import script from "./StarResources.vue?vue&type=script&lang=js&"
export * from "./StarResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9f18a7",
  null
  
)

export default component.exports